import { render, staticRenderFns } from "./PaymentBlock.vue?vue&type=template&id=f20f173e&scoped=true"
import script from "./PaymentBlock.vue?vue&type=script&lang=js"
export * from "./PaymentBlock.vue?vue&type=script&lang=js"
import style0 from "./PaymentBlock.vue?vue&type=style&index=0&id=f20f173e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20f173e",
  null
  
)

export default component.exports